import Link from 'next/link'
import React from 'react'
import { withI18n } from '~/hocs'

const License = ({ t, lng }) => {
  const licenses = [
    'top_download_1',
    // 'top_download_2',
    'top_download_3',
    'top_download_4',
  ]
  return (
    <div className="mt-3">
      <p style={{ margin: '0.5rem 0',fontWeight:"bold" }}>{t('license')}</p>
      {
        licenses.map((item, idx) => (
          <div key={idx} className="mb-1">
            <i className="far fa-check-circle" />
            <span className="ml-2 ">{t(item)}</span>
          </div>
        ))
      }
      <Link href="/terms" locale={lng}><a id="term_see_more" target="_blank">{t('video:term_see_more')}</a></Link>
    </div>
  )
}

export default withI18n(License)
